<template>
  <div class="pcd-settings-item" v-show="property.display !== false">
    <el-popover placement="left-start" trigger="hover">
      <div v-html="property.desc || property.text"></div>
      <label slot="reference">{{label}}</label>
    </el-popover>
    <el-popover placement="left-start" trigger="hover" v-if="property.demo">
      <div v-html="property.demo"></div>
      <label slot="reference" style="float:right">使用例子</label>
    </el-popover>

    <template v-if="property.editable !== false">
      <template v-if="dfTablecolumns && dfTablecolumns.length > 0 &&  property.name === 'name'">
        <el-select placeholder="请选择关联的表单元素"  v-model="property.value" @change="triggerChange" size="mini" filterable allow-create>
          <el-option v-for="dfTablecolumn in dfTablecolumns" :key="dfTablecolumn.name" :label="dfTablecolumn.name" :value="dfTablecolumn.name">
            <span style="float:left">{{ dfTablecolumn.name }}</span>
            <span style="float:right;color:#8492a6;font-size:13px">{{ dfTablecolumn.cmt }}</span>
          </el-option>
        </el-select>
      </template>
      <text-input-button @change="triggerChange" :property="property" :uiId="uiId" size="mini" :endpoint="endpoint" v-else-if="property.type === 'text'"></text-input-button>
      <model-select-button @change="triggerChange" :property="property" :dataType="property.dataType" :configColumn="property.configColumn" :configCondition="property.configCondition" :configOperation="property.configOperation" :endpoint="endpoint" size="mini" v-else-if="property.type === 'model'"></model-select-button>
      <form-select-button @change="triggerChange" :property="property" :dataType="property.dataType" :configColumn="property.configColumn" :configCondition="property.configCondition" :configOperation="property.configOperation" :endpoint="endpoint" :uiId="uiId" size="mini" v-else-if="property.type === 'dynamicForm'"></form-select-button>
      <api-data-source-select-button @change="triggerChange" :property="property" :dataType="property.dataType" :configColumn="property.configColumn" :configCondition="property.configCondition" :configOperation="property.configOperation" :endpoint="endpoint" size="mini" v-else-if="property.type === 'apiDataSource'"></api-data-source-select-button>
      <data-source-select-button @change="triggerChange" :property="property" :dataType="property.dataType" :configColumn="property.configColumn" :configCondition="property.configCondition" :configOperation="property.configOperation" :endpoint="endpoint" :uiId="uiId" size="mini" v-else-if="property.type === 'dataSource'"></data-source-select-button>
      <dict-select-button @change="triggerChange" :property="property" size="mini" v-else-if="property.type === 'dict'"></dict-select-button>
      <json-list-setter-button @change="triggerChange" :property="property" :columns="property.columns" size="mini" v-else-if="property.type === 'json-list'" :endpoint="endpoint" :uiId="uiId"></json-list-setter-button>
      <json-child-list-setter-button @change="triggerChange" :property="property" :columns="property.columns" size="mini" v-else-if="property.type === 'json-child-list'" :uiId="uiId"></json-child-list-setter-button>
      <image-upload-button @change="triggerChange" :property="property" :path="property.imagePath" v-else-if="property.type === 'image'"></image-upload-button>
      <el-color-picker v-model="property.value" @change="triggerChange" :show-alpha="property.colorFormat ? false : true" :color-format="property.colorFormat || 'rgb'" size="mini" v-else-if="property.type === 'color'"></el-color-picker>
      <el-input-number v-model="property.value" @change="triggerChange" :min="property.min" :max="property.max" size="mini" v-else-if="property.type === 'number'"></el-input-number>
      <date-picker-field @change="triggerChange" :property="property" value-format="yyyy-MM-dd" type="date" size="mini" v-else-if="property.type === 'date'"></date-picker-field>
      <date-picker-field @change="triggerChange" :property="property" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" size="mini" v-else-if="property.type === 'datetime'"></date-picker-field>
      <time-picker-field @change="triggerChange" :property="property" value-format="HH:mm:ss" size="mini" v-else-if="property.type === 'time'"></time-picker-field>
      <el-radio-group v-model="property.value" @change="triggerChange" size="mini" v-else-if="property.type === 'boolean' || property.type === 'radio'">
        <el-radio v-for="item in property.values" :key="item.value" :label="item.value" border>{{item.text}}</el-radio>
      </el-radio-group>
      <el-input v-model="property.value" @change="triggerChange" :rows="4" type="textarea" v-else-if="property.type === 'textarea'" clearable></el-input>
      <el-select v-model="property.value" @change="triggerChange" size="mini" v-else-if="property.type === 'valueProcessFn'">
        <el-option v-for="valueProcess in valueProcesses" :key="valueProcess.name" :value="valueProcess.name" :label="valueProcess.desc"></el-option>
      </el-select>
      <el-select v-model="property.value" @change="triggerChange" size="mini" v-else-if="property.values">
        <el-option v-for="item in property.values" :key="item.value" :label="item.text" :value="item.value"></el-option>
      </el-select>
      <el-input v-model="property.value" @change="triggerChange" size="mini" v-else></el-input>
    </template>
  </div>
</template>

<script>
import ModelSelectButton from './ModelSelectButton'
import TextInputButton from './TextInputButton'
import FormSelectButton from './FormSelectButton'
import DictSelectButton from './DictSelectButton'
import JsonListSetterButton from './JsonListSetterButton'
import JsonChildListSetterButton from './JsonChildListSetterButton'
import ImageUploadButton from './ImageUploadButton'
import ApiDataSourceSelectButton from './ApiDataSourceSelectButton'
import DataSourceSelectButton from './DataSourceSelectButton'
import DatePickerField from './DatePickerField'
import TimePickerField from './TimePickerField'

export default {
  name: 'property-field',
  components: {
    ModelSelectButton,
    TextInputButton,
    FormSelectButton,
    DictSelectButton,
    JsonListSetterButton,
    JsonChildListSetterButton,
    ImageUploadButton,
    ApiDataSourceSelectButton,
    DataSourceSelectButton,
    DatePickerField,
    TimePickerField
  },
  props: {
    endpoint: { type: String, required: true },
    uiId: { type: Number, required: true },
    label: { type: String, required: true },
    property: { type: Object, required: true },
    dfTablecolumns: { type: Array, required: false }
  },
  data () {
    return {
      valueProcesses: []
    }
  },
  created () {
    if (this.property.type === 'valueProcessFn') {
      this.$http.request({
        method: 'get',
        url: '/api/cgValueProcesses'
      }).then((res) => {
        this.valueProcesses = res.data.data
      })
    }
  },
  methods: {
    triggerChange () {
      this.$emit('change')
    }
  }
}
</script>

<style>
.pcd-settings-item{padding:0 6px 0 25px;border-bottom:1px dashed #ccc;}
.pcd-settings-item:last-child{border-bottom:0;}
.pcd-settings-item>span>label{font-size:14px;color:#606266;display:inline-block;padding:4px 0;}
.pcd-settings-item>div{display:block;margin-bottom:6px;}
.pcd-settings-item>.el-input-number{width:100%;}
.pcd-settings-item>.el-select{width:100%;}
.pcd-settings-item .el-input-group__append>button{padding-left:4px;padding-right:4px;}
.pcd-settings-item .el-button-group .el-button{padding:7px 11px;}
.pcd-settings-item .el-date-editor{width:100% !important;}
.property-field-table{margin:0 -20px;cursor:pointer;}
.property-field-table td{font-size:12px;line-height:12px;padding:7px 12px;border-left:1px solid #dcdfe6;}
.property-field-table td:first-child{font-size:16px;line-height:16px;padding:5px 10px;background-color:#fff;border-left:none;}
.pc-select-dialog-tip>p{text-indent:1rem;margin:10px 0;color:#999;}
.pc-select-dialog-tip>table{width:100%;background-color:#DDD;margin-top:20px;}
.pc-select-dialog-tip>table th{background-color:#FFF;padding:6px;text-align:left;}
.pc-select-dialog-tip>table td{background-color:#FFF;padding:6px;}
</style>
